import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import BuybackRequest from './components/BuybackRequest'
import PricingRequest from './components/PricingRequest'
import BuybackRequestDetails from './components/BuybackRequestDetails';
import ItemList from './components/ItemList';
import SerialBulk from './components/SerialBulk.vue';
import Vendor from './components/Vendor';
import Users from './components/Users';
import store from './store';
import UserNotSetup from './views/UserNotSetup';
import Logout from './views/Logout';
import VendorDashboard from './components/VendorDashboard';

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { requiresAuth: true},
    },
    {
      path: '/buyback-requests',
      name: 'Buyback',
      component: BuybackRequest,
      meta: { requiresAuth: true},
    },
    {
      path: '/buyback-requests/:id',
      name: 'BuybackDetails',
      component: BuybackRequestDetails,
      meta: { requiresAuth: true},
      props: true,
    },
    {
      path: '/pricing-requests',
      name: 'Pricing',
      component: PricingRequest,
      meta: { requiresAuth: true},
    },
    {
      path: '/admin/item-list',
      name: 'ItemList',
      component: ItemList,
      meta: { requiresAuth: true},
    },
    {
      path: '/admin/vendor',
      name: 'Vendor',
      component: Vendor,
      meta: { requiresAuth: true},
    },
    {
      path: '/admin/users',
      name: 'Users',
      component: Users,
      meta: { requiresAuth: true },
    },
    {
      path: '/serial-updates',
      name: 'SerialBulk',
      component: SerialBulk,
      meta: { requiresAuth: true },
    },
    {
      path: '/vendor-dashboard',
      name: 'VendorDashboard',
      component: VendorDashboard,
      meta: { requiresAuth: true },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/user-not-setup',
      name: 'UserNotSetup',
      component: UserNotSetup
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
  ]
});

export default router;

// see: https://gist.github.com/dabit3/2ff44a171d0cb430590dd56d76d28ebc
router.beforeResolve((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // let user;
    console.log('getting auth');
    Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then(() => {
      // if (data && data.signInUserSession) {
      //   user = data;
      // }
      console.log('got auth');
      store.dispatch('GET_LOOKUPS');
      next()
    }).catch(() => {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath,
        }
      });
    });
  }
  next()
})
